import {
  startOfWeek,
  add,
  isAfter,
  isBefore,
  startOfDay,
  endOfWeek,
  differenceInDays,
  set,
  nextMonday,
  isWeekend,
  getHours,
} from '@chilipiper/date-time'

import { CalendarDay } from '../types'

export const fillCalendarDays = (
  start = new Date(),
  length = 6,
  validateDayAvailability?: (day: Date) => boolean
): CalendarDay[] => {
  const startDay = startOfDay(start)
  const lastDayAvailable = add(startDay, { days: length })
  const firstWeekDay = startOfWeek(startDay)
  const daysToFill = differenceInDays(
    add(endOfWeek(lastDayAvailable), { seconds: 1 }),
    firstWeekDay
  )

  return Array.from(Array(daysToFill).keys()).map((_, index) => {
    const date = add(firstWeekDay, { days: index })
    const isUnavailable = validateDayAvailability && !validateDayAvailability(date)
    return {
      date,
      isAfterEnd: isAfter(date, lastDayAvailable),
      isBeforeStart: isBefore(date, startDay),
      isUnavailable,
    }
  })
}

const MEETING_DURATION = 30

export const generateDummySlots = (
  meetingDuration: number = MEETING_DURATION,
  startTimeInterval?: number,
  generateWeekendSlots = true
) => {
  const fromDay = isWeekend(new Date()) ? nextMonday() : new Date()
  const hour = getHours(new Date())

  return Array.from(Array(6).keys()).flatMap((_, dayIndex) => {
    const today = set(fromDay, { hours: hour, minutes: 0, seconds: 0 })
    const startedDay = startOfWeek(today, { weekStartsOn: 1 })
    const date = add(startedDay, { days: dayIndex, hours: hour + 2 })
    const minutesToAdd = startTimeInterval ?? meetingDuration
    return !generateWeekendSlots && isWeekend(date)
      ? []
      : Array.from(Array(6).keys()).map((_, index) => {
          const start = set(date, { minutes: minutesToAdd * index })
          return start.toISOString().replace(/.\d+Z$/g, 'Z')
        })
  })
}
